<template>
  <Layout :customization="customization" :settings="settings">
    <Content />
  </Layout>
</template>

<script setup>
import { computed } from 'vue';
import Layout from '@/components/layout.vue';
import Content from '@/components/content.vue';
import { useLandingPage } from '@/composables/useLandingPage';

const { customization, settings } = useLandingPage();
</script>